/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';

import grayPlus from '../../../assets/images/grey-plus.png';

const GrayPlus = ({ handleClick }) => (
  <div className="dropdown-btn btn-component-div">
    <button className="btn btn-link" onClick={handleClick}>
      <img src={grayPlus} alt="add" />
    </button>
  </div>
);

GrayPlus.propTypes = {
  handleClick: PropTypes.func
};

export default GrayPlus;
